import {Router} from "@profiscience/knockout-contrib-router";
import * as ko from 'knockout';
import {autobind, computed} from "knockout-decorators";
import {myTripsApi, TripDto} from "../../api/api-wrapper";
import globalState from "../../global-state";
import {postbox} from "../../components/util/postbox";

class ViewModel {
    /**
     * Template name.
     */
    public title: KnockoutObservable<string>;

    /**
     *  Path of the template picture
     */
    public templatePicturePath: KnockoutObservable<string>;

    /**
     * Image selection form visible?
     */
    public templatePicturesVisible: KnockoutObservable<boolean>;

    /**
     * The trip from which the template is created from.
     */
    public trip: TripDto;

    /**
     * An validated observable that checks if all validations in this page are valid.
     */
    public validationStatus: KnockoutObservable<any>;

    constructor() {
        this.trip = globalState.currentTrip;
        this.title = ko.observable(globalState.currentTrip.title).extend({required: true});
        this.templatePicturePath = ko.observable(globalState.currentTrip.imageUrl);
        this.templatePicturesVisible = ko.observable(false);

        this.validationStatus = ko.validatedObservable({
            title: this.title
        });
    }

    /**
     * Show/hide trip images selection.
     */
    @autobind
    public selectTemplatePicture() {
        if (!this.templatePicturesVisible()) {
            window.scrollTo({top: 0, left: 0, behavior: 'auto'});
            this.templatePicturesVisible(true);

        } else {
            window.scrollTo({top: 0, left: 0, behavior: 'auto'});
            this.templatePicturesVisible(false);
        }
    }

    /**
     * Display selected trip picture with fallback.
     */
    @computed
    public get templatePictureStyle() {
        return this.templatePicturePath() ? 'url(' + config.imagePath + '/' + this.templatePicturePath() + ')' :
            `url(${config.defaultImage})`;
    }

    @autobind
    public saveTemplate() {
        globalState.loading(true);
        return myTripsApi
            .createUserTemplate({
                name: this.title(),
                imageUrl: this.templatePicturePath(),
                tripId: this.trip.id
            })
            .then(createTemplateResponse => {
                console.debug('successfully saved template', createTemplateResponse.data.name);
                globalState.loading(false);

                postbox.clearErrors();
                postbox.addSuccess('userTemplate.successes.create', {title: this.title()});

                return Router.update(`/reise/${this.trip.id}/checkliste`, {
                    push: false,
                    force: false
                })
            })
            .catch(err => {
                console.error('failed to save template', err);
                globalState.loading(false);

                if (err.status === 409) {
                    postbox.addError('userTemplate.errors.alreadyExists', {title: this.title()})

                } else {
                    postbox.addError('userTemplate.errors.failedToCreateTemplate', {title: this.title()})
                }
            });
    }
}

export default <KnockoutLazyPageDefinition>{
    componentName: 'userTemplate',
    viewModel: ViewModel,
    template: require('./userTemplate.html')
}
